import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { cloneDeep } from 'lodash'
import { BatchTabType } from './types'
// types

interface ICurrentBatch {
  root: BatchTabType
  refresh?: boolean
  isbatchProcessorEnabled?: boolean
  processedFilters?: any
  processedGridApi?: any
  processedSort?: any
}

const batchSliceInitialState = {
  root: BatchTabType.Claims,
  refresh: false,
  isbatchProcessorEnabled: false,
  processedFilters: {},
  processedGridApi: null,
  processedSort: [],
} as ICurrentBatch

export const batchSlice = createSlice({
  name: 'batch',
  initialState: batchSliceInitialState,
  reducers: {
    updateCurrentBatch(state: ICurrentBatch, action: PayloadAction<ICurrentBatch>) {
      state.root = cloneDeep(action.payload.root)
      state.refresh = cloneDeep(action.payload.refresh)
      state.isbatchProcessorEnabled = cloneDeep(action.payload.isbatchProcessorEnabled)
    },
    updateProcessedFilters(state: ICurrentBatch, action: PayloadAction<{ filters: any }>) {
      state.processedFilters = cloneDeep(action.payload.filters)
    },
    resetProcessedFilters(state: ICurrentBatch) {
      state.processedFilters = {}
    },
    updateProcessedGridApi(state: ICurrentBatch, action: PayloadAction<any>) {
      state.processedGridApi = action.payload
    },
    updateProcessedSort(state: ICurrentBatch, action: PayloadAction<{ sort: any }>) {
      state.processedSort = cloneDeep(action.payload.sort)
    },
  },
})

export const {
  updateCurrentBatch,
  updateProcessedFilters,
  resetProcessedFilters,
  updateProcessedGridApi,
  updateProcessedSort,
} = batchSlice.actions

export const batchReducer = batchSlice.reducer
